export default "__VITE_PUBLIC_ASSET__166bb749__"